<div class="m-modal"
     ref="baseWindow">
    <slot name="trigger"></slot>
    <portal :target-el="portalTargetSelector"
            v-if="portalCreated">
        <transition name="m--is">
            <div v-show="propOpen"
                 v-if="portalMounted"
                 class="m-modal__wrap"
                 :class="[{ 'm--is-small': sizeSmall,
                            'm--is-large': sizeLarge,
                            'm--is-full-screen': sizeFullSceen,
                            'm--has-body-max-width': bodyMaxWidth,
                            'm--is-close-on-backdrop': closeOnBackdrop,
                            'm--is-disabled':disabled }, className ]"
                 @click.self="backdropClick()"
                 ref="modalWrap">
                <article class="m-modal__article"
                         ref="article">
                    <header class="m-modal__header">
                        <h2 v-if="title">{{ title }}</h2>
                        <slot name="header" />
                        <slot name="header-bouton">
                            <m-icon-button @click="closeModal()"
                                           icon-name="m-svg__close-clear"
                                           skin="dark"
                                           class="m-modal__close-button"
                                           :title="closeTitle"></m-icon-button>
                        </slot>
                    </header>
                    <div class="m-modal__body"
                         ref="body"
                         :class="{'m--is-android': hasKeyboard}">
                        <div class="m-modal__content"
                             :class="{ 'm--has-no-padding': !paddingBody }"
                             @focusin="onFocusIn"
                             @focusout="onFocusOut"
                             v-if="$slots.default">
                            <slot />
                        </div>
                        <footer v-if="hasKeyboard && $slots.footer"
                                class="m-modal__footer">
                            <slot name="footer" />
                        </footer>
                    </div>

                    <footer v-if="!hasKeyboard && $slots.footer"
                            class="m-modal__footer">
                        <slot name="footer" />
                    </footer>
                </article>
            </div>
        </transition>
    </portal>
</div>
